export default __webpack_public_path__ + "static/solomon1-55886d0eb42abb698437a763d4c0e748.png";